import { QuickAddLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <QuickAddLocationScreen />;
}
